








import { registerEvent, unregisterEvent, AxEventType } from '@aspenware-library/event-hub'
import { Component, Prop, Vue } from 'vue-property-decorator'

import CrossSellMiniCart from '@plugin/Common/components/cross-sell/CrossSellMiniCart.vue'
import { AddToCartEventInterface } from '@plugin/Common/interfaces/cross-sell/add-to-cart-event.interface'

@Component({
  components: {
    CrossSellMiniCart,
  },
})
export default class CrossSellMiniCartViewComponent extends Vue {
  @Prop({
    type: String,
    default: 'Based on your cart, you might also be interested in the following',
  })
  public title!: string

  private eventTimestamp: number = 0

  async mounted() {
    registerEvent<AddToCartEventInterface>(AxEventType.AddToCart, this.updateEventTimestamp)
    registerEvent<void>(AxEventType.RemoveFromCart, this.updateEventTimestamp)
    await this.updateEventTimestamp()
  }

  beforeDestroy() {
    unregisterEvent<AddToCartEventInterface>(AxEventType.AddToCart, this.updateEventTimestamp)
    unregisterEvent<void>(AxEventType.RemoveFromCart, this.updateEventTimestamp)
  }

  public async updateEventTimestamp(): Promise<void> {
    this.eventTimestamp = new Date().getMilliseconds()
  }
}
